export default __webpack_public_path__ + "static/media/gallery-5.b97a700b.jpg";